module.exports = __webpack_public_path__ + "static/media/40-iveco.1069f42c.jpg";